


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Guardería de mascotas": { initFrame:  0 },
    "Cancha": { initFrame:  5 },
    "Piscinas": { initFrame:  5 },
    "Pistas de triciclo": { initFrame:  15 },
    "Juegos infantiles": { initFrame:  15 },
    "Zonas de mascotas al aire libre": { initFrame:  0 },
    "Parqueadero bicicletas": { initFrame:  5 },
    "Salón niños": { initFrame:  120 },
    "Salón niñas": { initFrame:  120 },
    "Playground": { initFrame:  120 },
    "Baby Gym": { initFrame:  120 },
    "Terraza lúdica": { initFrame:  120 },
    "Cinema": { initFrame:  5 },
    "Salón de yoga o pilates": { initFrame:  5 },
    "Salón de juegos": { initFrame:  5 },
    "Chimenea": { initFrame:  5 },
    "BBQ": { initFrame:  5 },
    "Taller de cocina o hobbies": { initFrame:  5 },
    "Club house": { initFrame:  5 },
    "Coworking": { initFrame:  5 },
    "Observatorio": { initFrame:  5 },
    "Herbario": { initFrame:  5 },
    "Billar": { initFrame:  5 },
    "Salón de Videojuegos": { initFrame:  125 },

    //"EveryTransition": { importTransition: AllTransitions }
}
